import React from "react";
import SearchBar from "components/SearchBar/searchBar";
import InfoCard from "components/InfoCard";
import PropTypes from "prop-types";
import { exportUserList } from "slices/systemAdmin/actions/users";
import { setUserSearchTerm } from "slices/systemAdmin/systemAdminSlice";
import { useDispatch, useSelector } from "react-redux";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { DELETE_WORKSPACE_BUTTON } from "constants/systemAdmin";
import { exportModalTypes } from "layout/systemAdmin/workspaces/modals/ExportReportModal";

const UsersHeader = ({ licenseCount, licensedUsers, info }) => {
  const dispatch = useDispatch();
  const userSearchTerm = useSelector(
    (state) => state.systemAdmin.userSearchTerm
  );

  return (
    <div className="system_admin__header" data-testid="system-admin-header">
      <div className="system_admin__header__searchbar__container">
        <SearchBar
          searchMode={userSearchTerm !== ""}
          textFromProps={userSearchTerm}
          onSubmit={(searchTerm) => {
            dispatch(setUserSearchTerm(searchTerm));
          }}
          onClear={() => {
            dispatch(setUserSearchTerm(""));
          }}
        />
      </div>
      <div className="system_admin__header__button_holder">
        <div className="system_admin__header__button_holder__export__activity">
          <Button
            onClick={() =>
              dispatch(
                showModal(modalTypes.EXPORT_REPORT, {
                  exportType: exportModalTypes.activity,
                })
              )
            }
            variant={buttonVariants.borderless}
            content={<span>Export Activity Report</span>}
            dataTestId={DELETE_WORKSPACE_BUTTON}
          />
        </div>
        <div className="system_admin__header__button_holder__export__user_list">
          <Button
            onClick={() => dispatch(exportUserList())}
            variant={buttonVariants.borderless}
            content={<span>Export List of Users</span>}
          />
        </div>
        <div className="system_admin__header__button_holder__info">
          <InfoCard
            right={
              <span className="system_admin__header__button_holder__info__text">
                Total License <br /> Count
              </span>
            }
            left={
              <span className="system_admin__header__button_holder__info__number">
                {licenseCount}
              </span>
            }
          />
          <InfoCard
            right={
              <span className="system_admin__header__button_holder__info__text">
                Total Licensed <br /> Users
              </span>
            }
            left={
              <span className="system_admin__header__button_holder__info__number">
                {licensedUsers}
              </span>
            }
            info={info}
          />
        </div>
      </div>
    </div>
  );
};

export default UsersHeader;

UsersHeader.propTypes = {
  licenseCount: PropTypes.number.isRequired,
  licensedUsers: PropTypes.number.isRequired,
  info: PropTypes.string,
};
